export class AdminPlatformUsage {
  activeCompaniesLast30Days: number

  activeCustomersLast30Days: number

  ordersCreatedLast30Days: number

  manualExternalOrdersCreatedLast30Days: number

  manualExternalOrderCustomersLast30Days: number

  deliveredOrdersCount: number

  constructor(data: Partial<AdminPlatformUsage> = {}) {
    this.activeCompaniesLast30Days = data.activeCompaniesLast30Days ?? 0

    this.activeCustomersLast30Days = data.activeCustomersLast30Days ?? 0

    this.ordersCreatedLast30Days = data.ordersCreatedLast30Days ?? 0

    this.manualExternalOrdersCreatedLast30Days = data.manualExternalOrdersCreatedLast30Days ?? 0

    this.manualExternalOrderCustomersLast30Days = data.manualExternalOrderCustomersLast30Days ?? 0

    this.deliveredOrdersCount = data.deliveredOrdersCount ?? 0
  }
}
